export default (ctx) =>
  ({
    hoverImage: '',
    handleHover($event) {
      const { currentTarget } = $event
      this.hoverImage = currentTarget.dataset.hoverImage
    },
})
